import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import { CheckMark3Icon, SendIcon } from '@repo/ui/icons'

import {
  MedicalStatusEnum,
  medicalStatusEnumMapping
} from '../../enums/enrollment/medical-status.enum'
import { MedicalAttestationTypeEnumMapping } from '../../enums/medical-attestation-sending/medical-attestation-sending.enum'
import { StatusOptionWithIcon } from '../../utils'
import { MedicalAttestationSending } from '../medical-attestation-sending/medical-attestation-sending'

export class MedicalStatementProperties {
  static getMedicalAttestationLabel(medicalAttestation: MedicalAttestationSending) {
    return `Attestation ${MedicalAttestationTypeEnumMapping[medicalAttestation.type].toLowerCase()}`
  }

  /**
   * Get the badges for the medical attestation based on the enrollment status.
   */
  static getMedicalAttestationBadges({
    medicalAttestation,
    medicalStatus
  }: {
    medicalAttestation?: MedicalAttestationSending
    medicalStatus: MedicalStatusEnum
  }): StatusOptionWithIcon[] {
    if (!medicalAttestation) return []

    if (
      medicalStatus === MedicalStatusEnum.ATTESTATION_PENDING ||
      medicalStatus === MedicalStatusEnum.PENDING_LEC_MASTER_VALIDATION
    )
      return [
        ...medicalAttestation.sentAtHistory.map((sentAt) => ({
          label: `${MedicalStatementProperties.getMedicalAttestationLabel(medicalAttestation)} envoyée le ${DateFormatter.DDMMYYYY(sentAt)}`,
          variant: 'grey' as const
        })),
        {
          label: medicalStatusEnumMapping[medicalStatus].label,
          variant: medicalStatusEnumMapping[medicalStatus].variant,
          icon: medicalStatusEnumMapping[medicalStatus].icon
        }
      ]

    if (medicalStatus === MedicalStatusEnum.ATTESTATION_SIGNED)
      return [
        ...(medicalAttestation.acceptedAt
          ? [
              {
                label: `${MedicalStatementProperties.getMedicalAttestationLabel(medicalAttestation)} signée le ${DateFormatter.DDMMYYYY(medicalAttestation.acceptedAt)}`,
                variant: 'grey' as const
              }
            ]
          : []),
        {
          label: `${MedicalStatementProperties.getMedicalAttestationLabel(medicalAttestation)} signée`,
          variant: 'success',
          icon: () => <CheckMark3Icon color={tailwindColors.green.DEFAULT} />
        }
      ]

    return []
  }

  /**
   * Get the label for the medical attestation button.
   */
  static getMedicalStatementButton(
    actions: {
      onSend: () => void
      onResend: () => void
      onValidate: () => void
    },
    medicalAttestation?: MedicalAttestationSending,
    isMasterLec?: boolean,
    medicalStatus?: MedicalStatusEnum
  ) {
    if (
      !medicalAttestation &&
      medicalStatus !== MedicalStatusEnum.RAS &&
      medicalStatus !== MedicalStatusEnum.CHECK_LEVEL_0
    )
      return { label: "Envoyer l'attestation", icon: SendIcon, onClick: actions.onSend }
    if (
      (!isMasterLec && medicalStatus === MedicalStatusEnum.PENDING_LEC_MASTER_VALIDATION) ||
      medicalStatus === MedicalStatusEnum.ATTESTATION_PENDING
    )
      return { label: "Renvoyer l'attestation", icon: SendIcon, onClick: actions.onResend }
    if (isMasterLec && medicalStatus === MedicalStatusEnum.PENDING_LEC_MASTER_VALIDATION)
      return {
        label: "Valider l'envoi de l'attestation Medicament",
        icon: CheckMark3Icon,
        onClick: actions.onValidate
      }
  }
}
